module.exports = __webpack_public_path__ + "img/1.58127129.png";